import {
    ConfigViewType,
    FunctionType,
    ItemListView,
    NodeTypeName
} from "@app/types";
import BaseNodeModel from "../BaseNodeModel";

export default class DataAccessCompletionNodeModel extends BaseNodeModel {
    /**
     * Data access completion node model
     * @module DataAccessCompletionNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = NodeTypeName.dataAccessCompletion;
        this.props.colorClass = "green";
        this.props.iconClass = "check";
        this.DEFAULT_COLOR_CLASS = "green";
        this.applyProps(props);
    }

    getConfigViews() {
        const configView = [
            {type: "Input", label: this.getPropLabel("description"), key: "description"},
            { type: "Input", label: this.getPropLabel("data_access_timeout"), key: "timeoutSeconds", valRules: {"noEmpty": true}, inputRules: {"numberOnly": true } },
            {
                type: "Dropdown", key: "dataAccessNode", label: this.getPropLabel("data_access_node"), optionName: this.getPropLabel("data_access_node_opt"),
                options: window.apm.knowledgeBase.getAsyncDataAccessNodeInstances()
            },
            { type: ConfigViewType.oldItemList, label: this.getPropLabel("outputs"), key: "outputs", view: ItemListView.return },
            {
                functionType: FunctionType.custom,
                hideKey: "asynchronous",
                key: "customScript",
                type: ConfigViewType.function
            }
        ];
      
        return [
            ...this.getConfigViewNameField(),
            ...configView,
            ...[
                {type: "hr"},
                {type: "Textarea", label: this.getPropLabel("note"), key: "note", }
            ]
        ];
    }

    getDataAccessNodeInstance(id) {
        if(!id || !window.apm || !window.apm.knowledgeBase) {
            return {};
        }
        
        var dataAccessNode = window.apm.knowledgeBase.getAsyncDataAccessNodeInstances()
            .filter(node => node.value == id)[0];
        return dataAccessNode.node;
    }
    
}